import React from 'react';

const STEPS = ['1 · Your work', '2 · What Flowize does', '3 · First task'];

export default function FirstRunSteps({ current }) {
  return (
    <ol className="flex flex-wrap gap-2 text-sm font-semibold list-none p-0 m-0">
      {STEPS.map((label, i) => {
        const on = i + 1 === current;
        return (
          <li
            key={label}
            aria-current={on ? 'step' : undefined}
            className={`px-3 py-1.5 rounded-full border-1.5 ${
              on ? 'border-ink bg-hl-soft text-ink' : 'border-rule text-pencil'
            }`}
          >
            {label}
          </li>
        );
      })}
    </ol>
  );
}
